// extracted by mini-css-extract-plugin
export default {"overlay":"AB-z","bodyOpen":"BB-z","content":"CB-z","header":"DB-z","close":"EB-z","closeNoHeading":"FB-z"};